import React, { useRef, useEffect, useState} from 'react';
import {get_y1_T,binary_sys,substances, roundQuantity, get_x1_T,get_Txy_data} from './physical_models.js';
import {OutputGraph_xy_distill,DistillationColumn} from './output_graph.js';

const CN=0, EN = 1;

export function Distillation({params}){

    const {selectedModel, selectedSystem, tMax, tMin, lang} = params;
    const [P_in, setP_in] = useState(1.013);
    const [x1_in, setX1_in] = useState('');
    const [stageNow, setStageNow] = useState({stage:'NaN', T: 'NaN', x1: 'NaN', y1: 'NaN'});

    const sys = binary_sys[selectedModel][selectedSystem];
    const comps = [substances[sys.comp_1], substances[sys.comp_2]];
    const compsName = (lang===CN) ? [comps[0].name_cn, comps[1].name_cn] : [comps[0].name_en, comps[1].name_en];


    const [stagesUp, setStagesUp] = useState([]);
    const [stagesDn, setStagesDn] = useState([]);
    const [stage0, setStage0] = useState('');
    const {Txy_data, Tm, xm, azeotrope} = get_Txy_data(P_in,selectedModel, selectedSystem);
    const [columnSet, SetColumnSet] = useState(false);
    // stage = {x1, y1, T}

    const setting_cap = (lang===CN) ? ['这是一个全回流的精馏塔', '请设置操作压力和进料摩尔组成'] 
                                     : ['For a total reflux distillation column', 'Set operating pressure & feed composition (molar)'];
    const set_button_cap = (lang===CN) ? '设置/重置' : 'Set/Reset'
    const azeo_T_cap = (lang===CN) ? '恒沸温度' : 'Azeotropic T';
    const azeo_X_cap = (lang===CN) ? '恒沸组成' : 'Azeotropic x1';

    const press_unit_cn = 'bar', press_unit_en = 'bar';
    const press_unit = (lang===CN) ? press_unit_cn : press_unit_en;
  //  const tip_cap_cn = '可 向上 / 向下 添加理论塔板', tip_cap_en = 'Add theoretical stage upward / downward';
  //  const tip_cap = (lang===CN) ? tip_cap_cn : tip_cap_en;
    const Up_cap_cn = '向上', Up_cap_en = 'Upward';
    const Up_cap = (lang===CN) ? Up_cap_cn : Up_cap_en;
    const Dn_cap_cn = '向下', Dn_cap_en = 'Downward';
    const Dn_cap = (lang===CN) ? Dn_cap_cn : Dn_cap_en;
    const xytitle_cap_cn = 'x-y 相图', xytitle_cap_en = 'x-y Phase Diagram';
    const xytitle_cap= (lang===CN) ? xytitle_cap_cn : xytitle_cap_en;

    const P_in_Change = (e)=>{
        const newP = e.target.value;
        setP_in(newP);
      } 
    const x1_in_Change = (e)=>{
        const newX1 = e.target.value;
        setX1_in(newX1);
      }


    const handleSet = ()=>{

        setStagesUp([]);
        setStagesDn([]);

        let xn = parseFloat(x1_in), Pn = parseFloat(P_in);
        const alert_info_x = (lang===CN)? '请输入0-1之间的液相组成' : 'Please input a liquid composition btw 0 and 1.';
        const alert_info_P = (lang===CN)? '请输入0.1-10 bar之间的气压' : 'Please input a pressure btw 0.1 and 10 bar.'
        if (isNaN(xn) || xn >= 1.0 || xn <= 0.0 ) {
          alert(alert_info_x);
          return;
        };
        if (isNaN(Pn) || Pn > 10.0 || Pn < 0.1 ) {
          alert(alert_info_P);
          return;
        };    

        const ans = get_y1_T(Pn, xn, selectedModel, selectedSystem);

        setStage0({x1:xn, y1:ans.y1, T:ans.T_bubble});
        setStageNow({stage:0, x1:xn, y1:ans.y1, T:ans.T_bubble});
        SetColumnSet(true);
    }



    const handleAddUp = ()=>{
        if (stage0 === '') {
            alert('Please first set up a column by specifying feed-in composition and operating pressure');
            return;
        }
    
        let x1_now = stage0.y1, x1_prev = stage0.x1;
        if (stagesUp.length>0) {
            x1_now = stagesUp[stagesUp.length-1].y1;
            x1_prev = stagesUp[stagesUp.length-1].x1;
        }
        const ans = get_y1_T(P_in, x1_now, selectedModel, selectedSystem);
        const n = stagesUp.length;

        setStagesUp([...stagesUp, {x1_prev: x1_prev, x1:x1_now, y1:ans.y1, T:ans.T_bubble}])
        setStageNow({stage: n+1, x1:x1_now, y1:ans.y1, T:ans.T_bubble});

    }
        
    

    const handleAddDn = ()=>{
        if (stage0 === '') {
            alert('Please first set up a column by specifying feed-in composition and operating pressure');
            return;
        }
        let y1_now = stage0.x1;
        if (stagesDn.length>0) {
            y1_now = stagesDn[stagesDn.length-1].x1;
        }
        const ans = get_x1_T(P_in, y1_now, selectedModel, selectedSystem);
        const n = stagesDn.length;

        setStagesDn([...stagesDn, {y1:y1_now, x1:ans.x1, T:ans.T_bubble}]);
        setStageNow({stage:-n-1, y1:y1_now, x1:ans.x1, T:ans.T_bubble});
    } 
    

    return (
        
        <table>   
        <tr>

            <td width='270px'>  

                {setting_cap[0]} <br/>
                {setting_cap[1]} <br/><br/>

                <i>P</i><sub>0</sub> = <input type="number" step="0.1" min="0.1" max='10.0' placeholder='[0.1-10.0]' class='inputBox2' value={P_in} onChange={P_in_Change}/> {' '+press_unit}
                <br/>
                <i>x</i><sub>1</sub> = <input type="number" step="0.1" min="0.0" max='1.0' placeholder='[0.0-1.0]' class='inputBox3' value={x1_in} onChange={x1_in_Change}/> 
                
                &nbsp;&nbsp;<button onClick={handleSet}>{set_button_cap}</button><br/>
                <br/>
                {(azeotrope!==0) &&  <div>{azeo_T_cap}: {(Tm-273.15).toFixed(2)}<sup>o</sup>C<br/>{azeo_X_cap}: {xm.toFixed(4)}</div>} 
                <br/>
                Stage ID: <input class='inputBox1' value={stageNow.stage} readonly="true"/>&nbsp;
                <i>T</i> = <input class='inputBox1' value={roundQuantity(stageNow.T-273.15,2)} readonly="true"/>&nbsp;<sup>o</sup>C
                <br/>
                <i>x</i><sub>1</sub> = <input class='inputBox1' value={roundQuantity(stageNow.x1,4)} readonly="true"/>&nbsp;
                <i>y</i><sub>1</sub> = <input class='inputBox1' value={roundQuantity(stageNow.y1,4)} readonly="true"/>

                <br/>
                <br/>
                {(lang===CN) ? <div> <button onClick={handleAddUp}>{Up_cap}</button> 或 <button onClick={handleAddDn}>{Dn_cap}</button> 添加一块理论塔板</div>  
                :
                <div>
                    Add A Theoretical Stage <button onClick={handleAddUp}>{Up_cap}</button> or <button onClick={handleAddDn}>{Dn_cap}</button>

                </div>  
                }
                

            </td>

            <td width='340px'> 
            <tr align='center'>{xytitle_cap}</tr>
            <tr>
                <OutputGraph_xy_distill bgData={Txy_data} stage0={stage0} stagesUp={stagesUp} stagesDn={stagesDn} lang={lang}/>
            </tr>
            </td>

            <td width='390px'> 
                {(columnSet) &&<DistillationColumn stage0={stage0} stagesUp={stagesUp} stagesDn={stagesDn} comps={compsName} lang={lang}/>}

            </td>
         
        </tr>        


    </table>

    )
}
